import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import Loader from "../Loader/Loader";
import { Icon } from "@iconify/react/dist/iconify.js";
import {
  formatDateInAMPM,
  handleError,
  stripHtml,
} from "../../utils/helper";
import { readContract } from "@wagmi/core";
import { DAO_ABI } from "../../Contract/DAO_ABI";
import { DAO_CONTRACT_ADDRESS } from "../../utils/constant";
import { config } from "../../config";
import { useAppKitAccount } from "@reown/appkit/react";
import { formatEther } from "viem";
import { PROPOSAL_OPERATION } from "../../utils/enum";
import { usePublicClient, useWriteContract } from "wagmi";
import { toast } from "react-toastify";
import useApi from "../../hook/useApi";

const ProposalViewLayer = () => {
  const { address, isConnected } = useAppKitAccount();
  const [loading, setLoading] = useState(false);
  const publicClient = usePublicClient();
  const { writeContractAsync } = useWriteContract();
  const [proposal, setProposal] = useState({
    id: 0,
    proposer: "0x0000000000000000000000000000000000000000",
    title: "",
    description: "",
    createdAt: 0,
    startTime: 0,
    endTime: 0,
    forVotes: 0,
    againstVotes: 0,
    abstainVotes: 0,
    executed: false,
    cancelled: false,
  });
  const { id } = useParams();
  const location = useLocation();

  console.log("id.....", location?.state?.propId)

  const { AsyncPostApiCall } = useApi();

  const fetchProposal = async () => {
    try {
      setLoading(true);

      const res = await readContract(config, {
        abi: DAO_ABI,
        address: DAO_CONTRACT_ADDRESS,
        functionName: "proposals",
        args: [Number(id)],
        account: address,
      });

      console.log("res --- : ", res);

      setProposal({
        id: Number(res[0]),
        proposer: res[1],
        title: res[2],
        description: res[3],
        createdAt: Number(res[4]),
        startTime: Number(res[5]),
        endTime: Number(res[6]),
        forVotes: formatEther(res[7]), // ✅ convert wei → ETH
        againstVotes: formatEther(res[8]), // ✅ convert wei → ETH
        abstainVotes: formatEther(res[9]), // ✅ convert wei → ETH
        executed: String(res[10]),
        cancelled: String(res[11]),
      });
    } catch (e) {
      console.error("Error fetching proposal:", e);
    } finally {
      setLoading(false);
    }
  };

  const handleOperation = async (operationType, proposalId) => {
    try {
      setLoading(true);

      const contractData = {
        abi: DAO_ABI,
        address: DAO_CONTRACT_ADDRESS,
        functionName:
          operationType === PROPOSAL_OPERATION.CANCEL
            ? "cancelProposal"
            : "executeProposal",
        args: [Number(proposalId)],
      };

      await readContract(config, { ...contractData, account: address });

      const tx = await writeContractAsync(contractData);
      const receipt = await publicClient.waitForTransactionReceipt({
        hash: tx,
      });

      // const result = await AsyncGetApiCall("/faq/list", query.type ? { ...query, type: query.type } : {

      if (receipt?.status === "success") {
        const endpoint =
          operationType === PROPOSAL_OPERATION.CANCEL
            ? `/proposal/cancel?proposalId=${location?.state?.propId}`
            : `/proposal/execute?proposalId=${location?.state?.propId}`;

        const response = await AsyncPostApiCall(`${endpoint}`)
        console.log("response", response)

        if (response?.success) {

          toast.success(
            `Proposal ${operationType === PROPOSAL_OPERATION.CANCEL
              ? "Cancelled"
              : "Executed"
            } successfully`
          );

          await fetchProposal();
        }
      }
    } catch (error) {
      const err = handleError(error);
      console.log("Quorum update error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchProposal();
  }, [id, address]);

  if (loading || !proposal) return <Loader />;

  console.log("proposal?.executed", typeof proposal?.executed);
  console.log("proposal?.cancelled", typeof proposal?.cancelled);

  console.log("proposal data", proposal);

  return (
    <>
      <div className="row gy-4">
        <div className="col-lg-6">
          <div className="card mb-10">
            <div className="card-body p-24">
              <h5 className="mb-16">Proposal Details</h5>
              <ul>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 fw-semibold">Proposal Id</span> :
                  <span>{proposal.id}</span>
                </li>

                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 fw-semibold">Proposer</span> :
                  <span>{proposal?.proposer}</span>
                </li>

                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 fw-semibold">Title</span> :
                  <span>{proposal?.title}</span>
                </li>

                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 fw-semibold">Description</span> :
                  <textarea
                    className="w-70 text-break" // Bootstrap: Breaks long words to fit width
                    style={{
                      wordWrap: "break-word", // Fallback for older browsers: Wraps at arbitrary points
                      overflowWrap: "break-word", // Modern: Better word breaking
                      maxWidth: "100%", // Ensures no overflow beyond 70%
                      lineHeight: 1.4, // Optional: Improves readability on multi-line
                    }}
                    name="textarea"
                    readOnly
                  >
                    {stripHtml(proposal?.description)}
                  </textarea>
                </li>

                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 fw-semibold">Start Time</span> :
                  <span>{formatDateInAMPM(proposal?.startTime * 1000)}</span>
                </li>

                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 fw-semibold">End Time</span> :
                  <span>{formatDateInAMPM(proposal?.endTime * 1000)}</span>
                </li>

                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 fw-semibold">For Votes</span> :
                  <span>{proposal?.forVotes}</span>
                </li>

                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 fw-semibold">Against Votes</span> :
                  <span>{proposal?.againstVotes}</span>
                </li>

                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 fw-semibold">Abstain Votes</span> :
                  <span>{proposal?.abstainVotes}</span>
                </li>

                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 fw-semibold">Created At</span> :
                  <span>{formatDateInAMPM(proposal?.createdAt * 1000)}</span>
                </li>

                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 fw-semibold">Proposal Status</span> :
                  <span
                    className={`badge ${proposal?.executed === "true"
                      ? "bg-success-100 text-success-600"
                      : proposal?.cancelled === "true"
                        ? "bg-danger-100 text-danger-600"
                        : "bg-warning-100 text-warning-600"
                      } text-sm py-4 px-10 radius-4`}
                  >
                    {proposal?.executed === "true"
                      ? "Executed"
                      : proposal?.cancelled === "true"
                        ? "Cancelled"
                        : "Pending"}
                  </span>
                </li>
              </ul>

              {(isConnected && address) &&
                proposal?.executed === "false" &&
                proposal?.cancelled === "false" && (
                  <div className="mt-24 d-flex gap-3 flex-wrap">
                    <button
                      type="button"
                      className="btn btn-danger-600 radius-8 px-17 py-9 d-flex align-items-center gap-2"
                      onClick={async () => {
                        await handleOperation(
                          PROPOSAL_OPERATION.CANCEL,
                          proposal.id
                        );
                      }}
                    >
                      Cancel Proposal
                    </button>
                    <button
                      type="button"
                      className="btn btn-success-600 radius-8 px-17 py-9 d-flex align-items-center gap-2"
                      onClick={async () => {
                        await handleOperation(
                          PROPOSAL_OPERATION.EXECUTE,
                          proposal.id
                        );
                      }}
                    >
                      Execute Proposal
                    </button>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProposalViewLayer;
